import { Tag } from "antd";
import { SCENARIO_MAP } from "./scenarios";

const ScenarioCell = ({ record }) => {
  const scenarios = record?.reportScenarios || [];

  if (scenarios.length === 0) return <span dir="ltr">-</span>;

  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        gap: 4,
        alignItems: "flex-start",
      }}
    >
      {scenarios.map((s) => (
        <Tag key={s} color={SCENARIO_MAP[s]?.color || "default"} style={{ margin: 0 }}>
          {SCENARIO_MAP[s]?.label || s}
        </Tag>
      ))}
    </div>
  );
};

export default ScenarioCell;
